import { createContext, useContext, type ReactNode } from 'react';

export interface PageCrumb {
  readonly label: string;
  readonly to?: string | undefined;
}

/**
 * What the area around a screen knows about it and `PageHeader` draws (Figma "Esboço · perfis
 * internos"): the trail above the title and the icon in the box beside it. The backoffice route
 * provides it from the section the address belongs to, so the twenty screens under it gain the
 * redesign's header without each one restating where it lives.
 */
export interface PageContextValue {
  readonly crumbs?: readonly PageCrumb[] | undefined;
  readonly icon?: ReactNode;
}

export const PageContext = createContext<PageContextValue>({});

export function usePageContext(): PageContextValue {
  return useContext(PageContext);
}
